import { SimpleMesh } from '@pixi/mesh-extras';

SimpleMesh.prototype._renderCanvas = function _renderCanvas(renderer) {
  if (this.autoUpdate) {
    this.geometry.getBuffer("aVertexPosition").update();
  }
  if (this.shader.update) {
    this.shader.update();
  }
  this.calculateUvs();
  this.material._renderCanvas(renderer, this);
};
//# sourceMappingURL=SimpleMesh.mjs.map
